import React, { useEffect, useState } from 'react';
import { Row, Modal, Alert, Toast, Button, Tab, Tabs, OverlayTrigger, Tooltip } from 'react-bootstrap';
import api from '../seller-apis/api';
import { rejectedProducts, pendingProducts, approvedProducts, searchapprovedProduct, pendforapprovProducts } from '../seller-apis/apidataField';
import ProductCard from './common/ProductCard';
import NotApprPCard from './common/NotAprrPCard';
import ConfirmationModal from './common/ConfirmationModal';
import Myalert from './common/Myalert';
import Popup from './common/Popup';
import UpdtProPopup2 from './common/UpdtProPopup2';
import './inventry.css';
import { variables } from '../Variables.json'
import { useAlert } from 'react-alert';
import PaginationNew from './common/Pagination';
var activtab = "1";
var pendscrollLen = 0;
var apprscrollLen = 0;
var rejscrollLen = 0;
var pendforapprovLen = 0;


function HomeNew() {
  const alert = useAlert()
  const [pendingProductsList, setpendingProductsList] = useState([]);
  const [approvedProductsList, setapprovedProductsList] = useState([]);
  const [rejectedProductsList, setrejectedProductsList] = useState([]);
  const [pendforapprProductsList, setpendforapprProductsList] = useState([]);
  const [pendRecords, setpendRecords] = useState();
  const [appRecords, setappRecords] = useState();
  const [rejRecords, setrejRecords] = useState();
  const [pendfAppRecords, setpendfAppRecords] = useState();

  // Seller details

  const [sellerDetail, setsellerDetails] = useState("");
  
  // Pagination related
  const [selPgPendforappcat, setselPgPendforappcat] = useState(1)
  const [selectedPage, setselectedPage] = useState(1);
  const [selectedPagerejected, setselectedPagerejected] = useState(1);
  const [selPgPendforappman, setselPendforappman] = useState(1);

  // Popup related states

  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setCickedUpdateNo] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [selectedImgPopup, setselectedImgPopup] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [currDetailtype, setcurrDetailtype] = useState("approvedProductsList");

  // Confirmation Related States

  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedProduct, setselectedProduct] = useState();
  const [selectedId, setselectedId] = useState();
  const [activDeactiveState, setactivDeactiveState] = useState();
  const [deactiveReason, setdeactiveReason] = useState(false)
  // Alert related states

  const [alertshow, setalertShow] = useState(false)
  const [alertMessage, setalertMessage] = useState();
  const [alertType, setalertType] = useState();


  // Loader state

  const [loaderProduct, setloaderProduct] = useState("none")

  // Popup related

  const [isPopupVisible, setisPopupVisible] = useState("block");
  const [isPopupVisiblePendfapp, setisPopupVisiblePendfapp] = useState("block");
  const [isPopupVisiblePending, setisPopupVisiblePending] = useState("block");

  const [productNo, setproductNo] = useState(0);
  // Detail popup

  const [currDetail, setcurrDetail] = useState(0);
  const [currDetailPend, setcurrDetailPend] = useState(0);
  const [currDetailPendforapp, setcurrDetailPendforapp] = useState(0);

  // Toast

  const [showToast, setshowToast] = useState(false)
  const [ToastMsg, setToastMsg] = useState();
  // Combination related

  const [combAttri, setcombAttri] = useState([]);
  const [currentProupdt, setcurrentProupdt] = useState();


  // search related 

  const [searchProName, setsearchProName] = useState();

  // Pagination  related

  const [compforPaginationAppr, setcompforPaginationAppr] = useState("approvedPro");


  // Scroll related events


  const [isPendcrollBtnVis, setisPendcrollBtnVis] = useState("none");
  const [isApprscrollBtnVis, setisApprscrollBtnVis] = useState("none")
  const [isRejscrollBtnVis, setisRejscrollBtnVis] = useState("none")
  const [isPendforApprScrollBtnVis, setisPendforApprScrollBtnVis] = useState("none")
  const [loadText, setloadText] = useState("Load More")


  const [vendorId, setVendorId] = useState()
  useEffect(() => {
    setVendorId(localStorage.getItem('userId'))
    apprscrollLen = 1;
    pendforapprovLen = 1;
    rejscrollLen = 1
    pendscrollLen = 1;
    let filter = {
      "pageNo": "1"
    }
    
    // // Pending products
    api.product.newProductsRetrieveall(pendingProducts(filter))
      .then((res) => {
        console.log(res)
        setpendingProductsList(res.products)
        setpendRecords(res.totalRecords)
      })
      .catch(err => console.log(err))

    // Approved Products
    api.product.productsRetrieveall(approvedProducts(filter))
      .then((res) => {
        console.log(res)
        setapprovedProductsList(res.products)
        setappRecords(res.totalRecords)
      })
      .catch(err => console.log(err))

    // Rejected Products
    api.product.vExPrdReqRetrieveAll(rejectedProducts(filter))
      .then((res) => {
        console.log(res)
        setrejectedProductsList(res.data)
        setrejRecords(res.totalRecords)
      })
      .catch(err => console.log(err))

    // New request for approval Products
    api.product.vExPrdReqRetrieveAll(pendforapprovProducts(filter))
      .then((res) => {
        console.log(res)
        setpendforapprProductsList(res.data)
        setpendfAppRecords(res.totalRecords)
      })
      .catch(err => console.log(err))

    // Seller detail

    let body = {

    };


    api.auth.me(body).then(res => {
      console.log(res)
      setsellerDetails(res.data)

    })
      .catch(err => console.log(err));

  }, [])



  function productCheck(e, type) {
    setcombAttri([])
    if (type === "rejected") {
      console.log(type)
      for (let i = 0; i < rejectedProductsList.length; i++) {
        let baseImg;
        if (rejectedProductsList[i]._id === e) {
          console.log(rejectedProductsList[i]);
          setselectedProductPopup(rejectedProductsList[i].productName)
          if (rejectedProductsList[i].attributeList) {
            if (rejectedProductsList[i].attributeList.length > 0) {
              setcombAttri(rejectedProductsList[i].attributeList)
              setcurrentProupdt(rejectedProductsList[i])
            }
          }
          setupdtPopuprel({
            "SKU": rejectedProductsList[i].SKU,
            "price": rejectedProductsList[i].vendors[0].purchase_price
          })
          rejectedProductsList[i].images.map((item) => {
            if (item.baseImage === true) {
              if (item.image.startsWith("products")) {
                baseImg = item.image;
                setselectedImgPopup(baseImg)
              }
              else {
                let img = item.image.substr("41")
                baseImg = img;
                setselectedImgPopup(baseImg)
              }
            }
          })

          setCickedUpdateNo(e)
          setupdtProVisibility(true)
        }
      }
    }
    else {
      for (let i = 0; i < approvedProductsList.length; i++) {
        let baseImg;
        if (approvedProductsList[i]._id === e) {
          console.log(approvedProductsList[i]);
          setselectedProductPopup(approvedProductsList[i].productName)
          if (approvedProductsList[i].attributeList) {
            if (approvedProductsList[i].attributeList.length > 0) {
              setcombAttri(approvedProductsList[i].attributeList)
              setcurrentProupdt(approvedProductsList[i])
            }
          }
          setupdtPopuprel({
            "SKU": approvedProductsList[i].SKU,
            "price": approvedProductsList[i].vendors[0].purchase_price
          })
          approvedProductsList[i].images.map((item) => {
            if (item.baseImage === true) {
              if (item.image.startsWith("products")) {
                baseImg = item.image;
                setselectedImgPopup(baseImg)
              }
              else {
                let img = item.image.substr("41")
                baseImg = img;
                setselectedImgPopup(baseImg)
              }
            }
          })

          setCickedUpdateNo(e)
          setupdtProVisibility(true)
        }
      }
    }

  }


  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false)
    }
    else {
      setupdtProVisibility(true)
    }
  }
  // Pagination function

  function paginate(data) {
    setproductNo(0)
    let loaderDiv = document.getElementById("enNewLoader");
    let outerdiv = document.getElementById("outer");
    let filterData = {
      "pageNo": data.number
    }
    if (data.comp === "pendingPro") {
      setselPendforappman(data.number)
      setloaderProduct("block");
      loaderDiv.classList.add("loader-bt");
      outerdiv.classList.add("div-bk");
      // Pending products
      api.product.newProductsRetrieveall(pendingProducts(filterData))
        .then((res) => {
          setpendingProductsList(res.products)
          outerdiv.classList.remove("div-bk");
          loaderDiv.classList.remove("loader-bt");
          setloaderProduct("none")
        })
        .catch(err => {
          console.log(err)
          outerdiv.classList.remove("div-bk");
          loaderDiv.classList.remove("loader-bt");
        }
        )
    }
    else if(data.comp === "pendinfforappPro"){

      setselPgPendforappcat(data.number)
      // New request for approval Products
    api.product.vExPrdReqRetrieveAll(pendforapprovProducts(filterData))
    .then((res) => {
      console.log(res)
      setpendforapprProductsList(res.data)
    })
    .catch(err => console.log(err))
    }
    else if (data.comp === "approvedPro") {
      setselectedPage(data.number)
      setloaderProduct("block");
      loaderDiv.classList.add("loader-bt");
      outerdiv.classList.add("div-bk");

      // Approved Products
      api.product.productsRetrieveall(approvedProducts(filterData))
        .then((res) => {
          setapprovedProductsList(res.products)
          outerdiv.classList.remove("div-bk");
          loaderDiv.classList.remove("loader-bt");
          setloaderProduct("none")
        })
        .catch(err => {
          console.log(err)
          outerdiv.classList.remove("div-bk");
          setloaderProduct("none")
          loaderDiv.classList.remove("loader-bt");
        })
    }
    else if (data.comp === "rejectedPro") {
      setselectedPagerejected(data.number)

      // Rejected Products
      api.product.newProductsRetrieveall(pendingProducts(filterData))
        .then((res) => {
          setrejectedProductsList(res.products)
        })
        .catch(err => console.log(err))
    }
  }


  // Toggle

  function changeproductStatus(id, status) {
    let quantity;
    for (let i = 0; i < approvedProductsList.length; i++) {
      if (approvedProductsList[i]._id === id) {
        setselectedProduct(approvedProductsList[i].productName)
        quantity = approvedProductsList[i].vendors[0].stock;
      }
    }
    if (status === "on") {
      setdeactiveReason(false)

      setactivDeactiveState("activate")
      setselectedId(id)
      setmsgConfirmation("Are you sure you want to activate this product")
      setconfirmationState(true)
    }
    else if (status === "off") {
      console.log("jhfvhge")
      setdeactiveReason(true)
      setactivDeactiveState("deactivate")
      setselectedId(id)
      setmsgConfirmation("Are you sure you want to deactivate this product")
      setconfirmationState(true)
    }

  }


  // Update response

  function callbackResUpdate(res) {

    if (res === "product updated") {

      let filterData = {
        "pageNo": selectedPage
      }
      api.product.productsRetrieveall(approvedProducts(filterData))
        .then((res) => {
          setapprovedProductsList(res.products)
        })
        .catch(err => {
          console.log(err)
        })
      setalertType("lightgreen")
      setalertMessage("Product updated")
      setalertShow(true)
      setTimeout(() => {
        setalertShow(false)
      }, 3500);
      setupdtProVisibility(false)
    }
    else {
      setalertMessage("Failed to update")
      setalertType("red")
      setalertShow(true)
      setTimeout(() => {
        setalertShow(false)
      }, 3500);
      setupdtProVisibility(false)
    }
  }


  // Confirmation Modal

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }

  // Response Confirmation

  function responseconfirmation(ans, productId, reason) {
    if (ans === "yes") {
      apprscrollLen = 1;
      if (activDeactiveState === "activate") {
        let data = {
          "_id": productId,
          "vActive": "ACTIVE"
        }
        console.log(data)
        api.product.addToExProduct(data).then((res) => {
          console.log(res)
          let filter = {
            "pageNo": selectedPage
          }
          setconfirmationState(false)
          setcompforPaginationAppr("approvedPro")
          api.product.productsRetrieveall(approvedProducts(filter))
            .then((res) => {
              setapprovedProductsList(res.products)
              setappRecords(res.totalRecords)
            })
            .catch(err => console.log(err))
          setalertMessage("Product status updated")
          setalertShow(true)
          setTimeout(() => {
            setalertShow(false)
          }, 3500);
        }).catch((err) => {
          console.log(err)
        })
      }
      else if (activDeactiveState === "deactivate") {
        let data = {
          "_id": productId,
          "vActive": "INACTIVE",
          "reason": reason
        }
        api.product.addToExProduct(data).then((res) => {
          let filter = {
            "pageNo": selectedPage
          }
          setconfirmationState(false)
          setcompforPaginationAppr("approvedPro")
          api.product.productsRetrieveall(approvedProducts(filter))
            .then((res) => {
              setapprovedProductsList(res.products)
              setappRecords(res.totalRecords)
            })
            .catch(err => console.log(err))
          setalertMessage("Product status updated")
          setalertShow(true)
          setTimeout(() => {
            setalertShow(false)
          }, 3500);
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }


  //   Popup related functions


  function setpopupVisibility(e, from) {
    console.log(e)
    if (from === "pendforappr") {
      if (e > -1) {
        console.log(e)
        console.log(e)
        setcurrDetailPendforapp(e)
        setisPopupVisiblePendfapp("block")
      }
      else {
        console.log(e)
        setisPopupVisiblePendfapp("none")
        // setisPopupVisible("none")
      }
    }
    else if (from === "pending") {
      if (e > -1) {
        console.log(e)
        console.log(e)
        setcurrDetailPend(e)
        setisPopupVisiblePending("block")
      }
      else {
        console.log(e)
        setisPopupVisiblePending("none")
      }
    }
    else {
      if (e > -1) {
        console.log(e)
        setcurrDetail(e)
        setisPopupVisible("block")
      }
      else {
        console.log(e)
        setisPopupVisible("none")
        setisPopupVisiblePendfapp("none")
        setisPopupVisiblePending("none")
      }
    }
  }


  function henfun(e, type) {
    // setproductNo(0)
    // setproductNo(e)
    if (type === "rejectedhomenew") {
      setcurrDetailtype(rejectedProductsList)
    }
    else if (type === "pendforapprhomenew") {
      setcurrDetailtype(pendforapprProductsList)
    }
    else if (type === "pendinghomenew") {
      setcurrDetailtype(pendingProductsList)
    }
    else {
      setcurrDetailtype(approvedProductsList)
    }
  }



  // Search product function

  function searchProduct() {
    let loaderDiv = document.getElementById("enNewLoader");
    let outerdiv = document.getElementById("outer");
    apprscrollLen = 1;
    let filterProduct = {
      "pageNo": "1"
    }
    if (searchProName === undefined || searchProName === "") {

      api.product.productsRetrieveall(approvedProducts(filterProduct))
        .then((res) => {
          setapprovedProductsList(res.products)
          setappRecords(res.totalRecords)
        })
        .catch(err => console.log(err))


    }
    else {
      loaderDiv.classList.add("loader-bt");
      outerdiv.classList.add("div-bk");
      setloaderProduct("flex")
      setcompforPaginationAppr("appProSearch")
      api.product.productsRetrieveall(searchapprovedProduct(filterProduct, searchProName))
        .then((res) => {
          loaderDiv.classList.remove("loader-bt");
          outerdiv.classList.remove("div-bk");
          setloaderProduct("none")
          setapprovedProductsList(res.products)
          setappRecords(res.totalRecords)
        }).catch(err => {
          console.log(err)

        })
    }
  }


  // Set tab active

  function setinventorytabActive(e, tab) {
    activtab = tab
    let btns = document.getElementsByClassName("tabLabel");
    for (let i = 0; i < btns.length; i++) {
      if (btns[i].id === e) {
        btns[i].classList.add("invent-tab-Btn-Active")
      }
      else if (btns[i].className === "tab1 tabLabel invent-tab-Btn-Active") {
        btns[i].classList.remove("invent-tab-Btn-Active")
      }


    }


  }


  // Scroll function



  function handleScroll() {
    // const headHeight = document.getElementById("tab-cntns").offsetHeight;
    if (activtab === "1") {
      if (window.scrollY < window.innerHeight) {
        setisApprscrollBtnVis("none")
      }
      else {
        setisApprscrollBtnVis("block")

      }

    }
    else if (activtab === "2") {


      if (window.scrollY < window.innerHeight) {
        setisPendcrollBtnVis("none")
      }
      else {
        setisPendcrollBtnVis("block")

      }
    }
    else if (activtab === "3") {

      if (window.scrollY < window.innerHeight) {
        setisRejscrollBtnVis("none")
      }
      else {
        setisRejscrollBtnVis("block")

      }
    }
    else {

      if (window.scrollY < window.innerHeight) {
        setisPendforApprScrollBtnVis("none")
      }
      else {
        setisPendforApprScrollBtnVis("block")
      }
    }
  }

  window.addEventListener('scroll', handleScroll)






  // Handle approved products scroll
  // useEffect(() => {
  //   apprscrollLen = apprscrollLen + 1;
  //   if (apprscrollLen > 1) {
  //     setisApprscrollBtnVis("block")
  //   }
  //   let filterData = {
  //     "pageNo": apprscrollLen
  //   }
  //   if (compforPaginationAppr === "approvedPro") {
  //     api.product.productsRetrieveall(approvedProducts(filterData))
  //       .then((res) => {
  //         console.log(res)
  //         setloaderProduct("flex")
  //         if (res.products.length === 0) {
  //           setloaderProduct("none")
  //         }
  //         setapprovedProductsList(approvedProductsList => approvedProductsList.concat(res.products))
  //       })
  //       .catch(err => {
  //         console.log(err)
  //         setloaderProduct("none")
  //       })
  //   }
  //   else if (compforPaginationAppr === "appProSearch") {
  //     api.product.productsRetrieveall(searchapprovedProduct(filterData, searchProName))
  //       .then((res) => {
  //         if (res.products.length > 0) {
  //           setloaderProduct("none")
  //         }
  //         setapprovedProductsList(approvedProductsList => approvedProductsList.concat(res.products))
  //       }).catch(err => {
  //         console.log(err)
  //         setloaderProduct("none")
  //       })
  //   }
  // }, [apprscroll])



  function detail() {
    alert.info("Please visit inventory tab for product details")
  }

  function showDetail() {
    alert.info("Please visit inventory tab for product details")
  }



  return (
    <>

      <div className="oM-c container inventry-page" id="outer">
        {alertshow === true ?
          <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
            <Myalert
              message={alertMessage}
            />
          </Alert> : <></>
        }

        <div className="p-0  pr" >

          <div className="d-flex flex-row-reverse add-new ">

            {/* <span className='add-bell' > <img src='/add-bell.png'></img></span> */}
          </div>

          <Row className=" card card1 mx-4 d-flex pb-1">
            <div className="col-10">
              <h6 className="user">{sellerDetail.name}
                {/* {sellerDetail.trm ?
                       <Badge bg="success" className='mx-2'><i class="bi bi-check-circle-fill"></i> Verified Seller</Badge>
                        
                     :<a href="/t&c" className='mx-2'>
                        <Badge bg="danger"><i class="fa fa-exclamation" aria-hidden="true"></i> Verification Pending</Badge>
                     </a>
                    
                     } */}
              </h6>
              <span className="gry " ><i className="fa fa-phone fs-17  me-3"></i><span className="fs-13 "> {sellerDetail.phoneNumber}</span></span>


            </div>
            <div className="col-2 seller_img_home">
              {sellerDetail.avatar ? <img src={"https://s3.toolsvilla.com/mob/avatar/" + sellerDetail.avatar} className="w-100 h-100" alt="user"></img> :
                <img src='./user.png' className="" alt="user"></img>}
            </div>
          </Row>
          <div className="col-12 text-center pl-0 pr-2 py-1 fs-12 text-red f-500"><i className="fa fa-info-circle"></i>  Profile verification pending</div>
          {/* tabs */}

          <div className="tabset tabset1  ">

            <input type="radio" name="tabset" id="tab1" aria-controls="approved" onClick={() => setinventorytabActive("tablabel1", "1")} defaultChecked />
            <label for="tab1" id="tablabel1" className="tab1 tabLabel invent-tab-Btn-Active">Approved Products ({appRecords})</label>

            {/* <input type="radio" name="tabset" id="tab2" aria-controls="pending" onClick={() => setinventorytabActive("tablabel2","2")}/>
            <label for="tab2" id="tablabel2" className="tab1 tabLabel">PENDING PRODUCTS ({pendRecords})</label> */}


            <input type="radio" name="tabset" id="tab3" aria-controls="rejected" onClick={() => setinventorytabActive("tablabel3", "3")} />
            <label for="tab3" id="tablabel3" className="tab1 tabLabel">Rejected Products({rejRecords})</label>
            <input type="radio" name="tabset" id="tab4" aria-controls="rejected" onClick={() => setinventorytabActive("tablabel4", "4")} />
            <label for="tab4" id="tablabel4" className="tab1 tabLabel">New Product Request ({parseInt(pendfAppRecords) +parseInt(pendRecords)})</label>


            <div id="tab-cntns" className="tab-panels pt-1 page-bg" >


              {/* Approved Products */}
              <section id="approved" className="tab-panel">
                <table>
                  <thead>
                    <tr className='table_ord_title_row'>

                      <th className='thead_title pt-2 pb-2' style={{ "width": "5%" }}>Product Image

                      </th>

                      <th className='thead_title pb-1' style={{ "width": "20%" }}>Product Name<br></br>

                      </th>

                      <th className='thead_title' style={{ "width": "10%" }}>Product Status</th>

                      <th className='thead_title' style={{ "width": "7%" }}>Transfer price  <OverlayTrigger
                        key="transfer"
                        placement="bottom"
                        overlay={
                          <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                            <p className='fs-8 f-500 order_page_tooltip_1'>{variables.transferPriceText}</p>
                          </Tooltip>
                        }
                      >
                        <i class="bi bi-info-circle ms-1"></i>
                      </OverlayTrigger></th>

                      <th className='thead_title' style={{ "width": "10%" }}>Action</th>
                    </tr>

                  </thead>
                  <tbody>
                    {appRecords > 0 ? approvedProductsList.map((item, index) => {
                      let baseImg;
                      let lowestPrice = undefined
                      let taxClass;
                      item.images.map((item) => {
                        if (item.baseImage === true) {
                          if (item.image.startsWith("products")) {
                            baseImg = item.image;
                          }
                          else {
                            let img = item.image.substr("41")
                            baseImg = img;
                          }
                        }
                      })
                      if (item.vendors[0] && item.vendors[0].taxClass && item.vendors[0].taxClass !== "") {
                        taxClass = item.vendors[0].taxClass
                      }
                      else {
                        taxClass = item.taxClass
                      }
                      let date = new Date(item.vendors[0].updated_at);
                      let d = date.toUTCString(item.vendors[0].updated_at);
                      let newd = d.substr(4, 12)
                      if (item.combination) {
                        let vendorfirstComb = [];

                        if (item.vendors[0] && item.vendors[0].combination.length > 0) {
                          var offerArry = [];
                          var combarry = [];
                          var singleAttr = true;
                          if (item.combination[0] && item.combination[0].value && item.combination[0].value.length > 1) {
                            singleAttr = false
                          }
                          item.vendors[0].combination.map((vitem, vindex) => {
                            item.combination.map((pitem, pindex) => {
                              if (pitem.url === vitem.url && vitem.purchase_price && vitem.purchase_price !== undefined && pitem.active) {
                                if (vindex === 0) {
                                  if (pitem.lowestPrice < vitem.purchase_price)
                                    lowestPrice = pitem.lowestPrice
                                }
                                if (!singleAttr) {
                                  let com = "";
                                  pitem.value.map((aitem, aindex) => {
                                    com = com + aitem;
                                    if (aindex !== pitem.value.length - 1) {
                                      com = com + " x "
                                    }
                                  })
                                  combarry.push({ "com": com, "price": vitem.purchase_price, "lowestPrice": pitem.lowestPrice, "status": vitem.vActive === "ACTIVE" || vitem.vActive === "INACTIVE_REQ" ? "In Stock" : "Out of Stock", "url": vitem.url })
                                  if (vitem.prSts && vitem.prSts === "V_PENDING") {
                                    let cmb = "";
                                    pitem.value.map((litem, lindex) => {
                                      cmb = cmb + litem;
                                      if (lindex !== pitem.value.length - 1) {
                                        cmb = cmb + " x "
                                      }
                                    })
                                    offerArry.push({ "cmb": cmb, "url": vitem.url })
                                  }

                                }
                                else {
                                  let com = { "com": pitem.value[0], "price": vitem.purchase_price, "lowestPrice": pitem.lowestPrice, "status": vitem.vActive === "ACTIVE" || vitem.vActive === "INACTIVE_REQ" ? "In Stock" : "Out of Stock", "url": vitem.url }
                                  combarry.push(com)
                                  if (vitem.prSts && vitem.prSts === "V_PENDING") {
                                    offerArry.push({ "cmb": pitem.value[0], "url": vitem.url })
                                  }
                                }
                              }
                            })
                          })
                          return (
                            <ProductCard id={index}
                              SKU={item.SKU}
                              updatedon={newd}
                              urlKey={item.urlKey}
                              lowestPrice={lowestPrice}
                              // defUrl={defUrl}
                              shortDescription={item.shortDescription}
                              lead={item._id}
                              productName={item.productName}
                              offerForArr={offerArry}
                              // price={firstPrice}
                              quantity={item.vendors[0].combination[0].stock}
                              status={item.vendors[0].vActive}
                              weight={item.vendors[0].combination[0].weight}
                              requestFrom="inventory"
                              vendActive={item.vendors[0].active}
                              callback={productCheck}
                              image={baseImg}
                              vendorfirstComb={vendorfirstComb}
                              combination={combarry}
                              vendor={item.vendors[0]}
                              changeproductStatusFun={changeproductStatus}
                              popupVisibility={setpopupVisibility}
                              fun={henfun}
                            />
                          )

                        }
                        else {
                          return (
                            <ProductCard id={index}
                              SKU={item.SKU}
                              updatedon={newd}
                              urlKey={item.urlKey}
                              lowestPrice={item.lowestPrice}
                              shortDescription={item.shortDescription}
                              lead={item._id}
                              vendor={item.vendors[0]}
                              productName={item.productName}
                              price={item.vendors[0].purchase_price}
                              quantity={item.vendors[0].stock}
                              status={item.vendors[0].vActive}
                              vendActive={item.vendors[0].active}
                              weight={item.vendors[0].weight}
                              requestFrom="inventory"
                              callback={productCheck}
                              image={baseImg}
                              changeproductStatusFun={changeproductStatus}
                              popupVisibility={setpopupVisibility}
                              fun={henfun}
                            />
                          )

                        }
                      }
                      else {
                        return (
                          <ProductCard id={index}
                            SKU={item.SKU}
                            updatedon={newd}
                            vendor={item.vendors[0]}
                            urlKey={item.urlKey}
                            lowestPrice={item.lowestPrice}
                            shortDescription={item.shortDescription}
                            lead={item._id}
                            productName={item.productName}
                            price={item.vendors[0].purchase_price}
                            quantity={item.vendors[0].stock}
                            status={item.vendors[0].vActive}
                            weight={item.vendors[0].weight}
                            vendActive={item.vendors[0].active}
                            requestFrom="inventory"
                            callback={productCheck}
                            image={baseImg}
                            changeproductStatusFun={changeproductStatus}
                            popupVisibility={setpopupVisibility}
                            fun={henfun}
                          />
                        )
                      }

                    }) : <div className="card card-1">
                      No Approved Products
                    </div>}
                  </tbody>
                </table>

                <div class="d-flex justify-content-center" id="enNewLoader">
                  <div class="spinner-border" role="status" style={{ "display": loaderProduct }}>
                    <span class="sr-only"></span>
                  </div>
                </div>

                <PaginationNew
                  number={appRecords}
                  paginate={paginate}
                  activ={selectedPage}
                  comp="approvedPro"
                />





                {updtProVisibility === true && combAttri.length > 0 && <UpdtProPopup2
                  lead={clickedUpdateNo}
                  productName={selectedProductPopup}
                  callbackResFun={callbackResUpdate}
                  combattr={combAttri}
                  img={selectedImgPopup}
                  detail={updtPopuprel}
                  product={currentProupdt}
                  Popupvisible="block"
                  from="approved-Pro"
                  Popupvisibilityfun={checkpopupvisibility}
                />
                }
                {updtProVisibility === true && combAttri.length < 1 && <UpdtProPopup2
                  lead={clickedUpdateNo}
                  img={selectedImgPopup}
                  productName={selectedProductPopup}
                  detail={updtPopuprel}
                  callbackResFun={callbackResUpdate}
                  Popupvisible="block"
                  from="approved-Pro"
                  Popupvisibilityfun={checkpopupvisibility}
                />}
                {/* <div className='scrolltoptnCnt' style={{ "display": isApprscrollBtnVis }}>
                  <a href='#approved'>
                    <Button variant="dark"><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                  </a>

                </div> */}
                {approvedProductsList.length > 0 ? <div id="popup1" className="overlay" style={{ "display": isPopupVisible }}>
                  <Popup
                    name={approvedProductsList[currDetail].productName}
                    price={approvedProductsList[currDetail].vendors[0].purchase_price}
                    SKU={approvedProductsList[currDetail].SKU}
                    descriptionNew={approvedProductsList[currDetail]?.descriptionNew||[]}
                    specificationNew={approvedProductsList[currDetail]?.specificationNew||[]}
                    popupVisibility={setpopupVisibility}
                    images={approvedProductsList[currDetail].images}
                    description={approvedProductsList[currDetail].description}
                    sdescription={approvedProductsList[currDetail].shortDescription}
                    callback={productCheck}
                    lead={approvedProductsList[currDetail]._id}
                  />
                </div> : <></>}

              </section>


              {/* Rejected Products */}
              <section id="rejected" className="tab-panel">
                <table>
                  <thead>
                    <tr className='table_ord_title_row'>

                      <th className='thead_title pt-2 pb-2' style={{ "width": "5%" }}>Product Image

                      </th>

                      <th className='thead_title pb-1' style={{ "width": "20%" }}>Product Name<br></br>

                      </th>

                      <th className='thead_title' style={{ "width": "7%" }}>Transfer price  <OverlayTrigger
                        key="transfer"
                        placement="bottom"
                        overlay={
                          <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                            <p className='fs-8 f-500 order_page_tooltip_1'>{variables.transferPriceText}</p>
                          </Tooltip>
                        }
                      >
                        <i class="bi bi-info-circle ms-1"></i>
                      </OverlayTrigger></th>

                      <th className='thead_title' style={{ "width": "10%" }}>Reject Reason</th>

                      <th className='thead_title' style={{ "width": "10%" }}>Action</th>
                    </tr>

                  </thead>
                  <tbody>
                    {rejRecords > 0 ? rejectedProductsList.map((item, index) => {
                      let baseImg;
                      item.product.images.map((item) => {
                        if (item.baseImage === true) {
                          if (item.image.startsWith("products")) {
                            baseImg = item.image;
                          }
                          else {
                            let img = item.image.substr("41")

                            baseImg = img;
                          }
                        }
                      })
                      if (item.combination) {

                        return (
                          <NotApprPCard id={index}
                            lead={item._id}
                            productName={item.product.productName}
                            price={item.purchase_price}
                            quantity={item.quantity}
                            image={baseImg}
                            weight={item.weight}
                            remark={item.reason}
                            callback={productCheck}
                            totalComb={item.product.combination}
                            activePage={selectedPagerejected}
                            from="rejectedRecords"
                            detail={showDetail}
                            combination={item.combination}
                            fun={henfun}
                            popupVisibility={setpopupVisibility}
                          />
                        )
                      }
                      else {
                        return (
                          <NotApprPCard id={index}
                            lead={item._id}
                            productName={item.product.productName}
                            price={item.purchase_price}
                            quantity={item.quantity}
                            image={baseImg}
                            weight={item.weight}
                            remark={item.reason}
                            activePage={selectedPagerejected}
                            from="rejectedRecords"
                            fun={henfun}
                            detail={showDetail}
                            popupVisibility={setpopupVisibility}
                          />
                        )
                      }

                    }) : <div className="card card-1">
                      No Rejected Products
                    </div>}
                  </tbody>
                </table>


                <div className='scrolltoptnCnt' style={{ "display": isRejscrollBtnVis }}>
                  <a href='#rejected'>
                    <Button variant="dark"><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                  </a>

                </div>
                <PaginationNew
                  number={rejRecords}
                  paginate={paginate}
                  activ={selectedPagerejected}
                  comp="rejectedPro"
                />




              </section>

              {/* New pending requests */}

              <section id="pending" className="tab-panel">


                <Tabs
                  defaultActiveKey="pending"
                  transition={false}
                  id="noanim-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="pending" title="New Products Added">
                    <table>
                      <thead>
                        <tr className='table_ord_title_row'>

                          <th className='thead_title pt-2 pb-2' style={{ "width": "5%" }}>Product Image

                          </th>

                          <th className='thead_title pb-1' style={{ "width": "20%" }}>Product Name<br></br>

                          </th>

                          <th className='thead_title' style={{ "width": "7%" }}>Transfer price  <OverlayTrigger
                            key="transfer"
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                                <p className='fs-8 f-500 order_page_tooltip_1'>{variables.transferPriceText}</p>
                              </Tooltip>
                            }
                          >
                            <i class="bi bi-info-circle ms-1"></i>
                          </OverlayTrigger></th>

                          <th className='thead_title' style={{ "width": "10%" }}>Requested On</th>

                          <th className='thead_title' style={{ "width": "10%" }}>Action</th>
                        </tr>

                      </thead>
                      <tbody>
                        {pendRecords > 0 ? pendingProductsList.map((item, index) => {
                          let baseImg;
                          item.images.map((item) => {
                            if (item.baseImage === true) {
                              if (item.image.startsWith("products")) {
                                baseImg = "mob/" + item.image;
                              }
                              else {
                                let img = item.image.substr("41")

                                baseImg = img;
                              }
                            }
                          })
                          let date = new Date(item.updatedAt);
                          let d = date.toUTCString(item.updatedAt);
                          let newd = d.substr(4, 12);
                          return (
                            <NotApprPCard id={index}
                              taxClass={item.taxClass}
                              lead={item._id}
                              productName={item.productName}
                              price={item.price}
                              quantity={item.quantity}
                              status={item.status}
                              image={baseImg}
                              from="pendingProductshomenew"
                              weight={item.weight}
                              date={newd}
                              activePage={selectedPage}
                              detail={detail}
                              popupVisibility={setpopupVisibility}
                              fun={henfun}
                            />
                          )
                        }) : <div className="card card-1">
                          Nothing here
                        </div>}
                      </tbody>
                    </table>
                    <PaginationNew
                  number={pendRecords}
                  paginate={paginate}
                  activ={selPgPendforappman}
                  comp="pendingPro"
                />

                    <div className='scrolltoptnCnt' style={{ "display": isPendcrollBtnVis }}>
                      <a href='#pending'>
                        <Button variant="dark"><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                      </a>

                    </div>
                    {pendingProductsList && pendingProductsList.length > 0 ? <div id="popup3" className="overlay" style={{ "display": isPopupVisiblePending }}>
                      <Popup
                        name={pendingProductsList[currDetailPend].productName}
                        price={pendingProductsList[currDetailPend].price}
                        from="pendingPro"
                        // SKU={pendingProductsList[currDetailPend].SKU}
                        popupVisibility={setpopupVisibility}
                        images={pendingProductsList[currDetailPend].images}
                        description={pendingProductsList[currDetailPend].description}
                        sdescription={pendingProductsList[currDetailPend].shortDescription}
                        descriptionNew={pendingProductsList[currDetailPend]?.descriptionNew||[]}
                        specificationNew={pendingProductsList[currDetailPend]?.specificationNew||[]}
                        callback={productCheck}
                        lead={pendingProductsList[currDetailPend]._id}
                      />
                    </div> : <></>}
                  </Tab>
                  <Tab eventKey="newrequest" id="pendforappr" title="Requested From Catalogue">
                    <table className='ord_table' style={{ "width": "100%" }}>
                      <thead>
                        <tr className='table_ord_title_row'>

                          <th className='thead_title pt-2 pb-2' style={{ "width": "5%" }}>Product Image

                          </th>

                          <th className='thead_title pb-1' style={{ "width": "20%" }}>Product Name<br></br>

                          </th>

                          <th className='thead_title' style={{ "width": "7%" }}>Transfer price  <OverlayTrigger
                            key="transfer"
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                                <p className='fs-8 f-500 order_page_tooltip_1'>{variables.transferPriceText}</p>
                              </Tooltip>
                            }
                          >
                            <i class="bi bi-info-circle ms-1"></i>
                          </OverlayTrigger></th>

                          <th className='thead_title' style={{ "width": "10%" }}>Requested On</th>

                          <th className='thead_title' style={{ "width": "10%" }}>Action</th>
                        </tr>

                      </thead>
                      <tbody>
                        {pendfAppRecords > 0 ? pendforapprProductsList.map((item, index) => {
                          let baseImg;
                          let taxClass = item.product.taxClass
                          item.product.images.map((item) => {
                            if (item.baseImage === true) {
                              if (item.image.startsWith("products")) {
                                baseImg = item.image;
                              }
                              else if (item.image.startsWith("https:")) {
                                let img = item.image.substr("41")
                                baseImg = img;
                              }
                              else {
                                baseImg = item.image;
                              }
                            }
                          })
                          let date = new Date(item.updatedAt);
                          let d = date.toUTCString(item.updatedAt);
                          let newd = d.substr(4, 12);
                          item.product.vendors && item.product.vendors.map((vitem, vindex) => {
                            if (vendorId === vitem.vendor_id) {
                              if (vitem.taxClass && vitem.taxClass !== undefined && vitem.taxClass !== "") {
                                taxClass = vitem.taxClass
                              }
                            }
                          })
                          if (item.combination && item.combination.url && item.combination.url !== undefined && item.combination.url !== "" && item.combination.url !== "notfound") {
                            var combarry = [];
                            var singleAttr = true;
                            if (item.product.combination[0] && item.product.combination[0].value && item.product.combination[0].value.length > 1) {
                              singleAttr = false
                            }
                            let obj = [];
                            item.product.combination.map((pitem, pindex) => {
                              if (pitem.url === item.combination.url && item.combination.purchase_price && item.combination.purchase_price !== undefined) {
                                if (!singleAttr) {
                                  let com = "";
                                  pitem.value.map((aitem, aindex) => {
                                    com = com + aitem;
                                    if (aindex !== pitem.value.length - 1) {
                                      com = com + " x "
                                    }
                                  })
                                  combarry.push({ "com": com, "price": item.combination.purchase_price })
                                }
                                else {
                                  let com = { "com": pitem.value[0], "price": item.combination.purchase_price }
                                  combarry.push(com)
                                }
                              }
                            })

                            return (
                              <ProductCard id={index}
                                taxClass={taxClass}
                                SKU={item.product.SKU}
                                updatedon={newd}
                                urlKey={item.urlKey}
                                lowestPrice={item.lowestPrice}
                                shortDescription={item.shortDescription}
                                lead={item._id}
                                productName={item.product.productName}
                                price={item.purchase_price}
                                status={item.status}
                                detail={showDetail}
                                requestFrom="inventory"
                                combination={combarry}
                                image={baseImg}
                              />
                            )
                          }
                          else {
                            return (
                              <ProductCard id={index}
                                taxClass={taxClass}
                                SKU={item.product.SKU}
                                detail={showDetail}
                                updatedon={newd}
                                urlKey={item.urlKey}
                                lowestPrice={item.lowestPrice}
                                shortDescription={item.shortDescription}
                                lead={item._id}
                                productName={item.product.productName}
                                price={item.purchase_price}
                                status={item.status}
                                requestFrom="inventory"
                                image={baseImg}
                              />
                            )

                          }

                        }) : <div className="card card-1">
                          Nothing here
                        </div>}
                      </tbody>

                    </table>

                    <div class="d-flex justify-content-center" id="enNewLoader">
                      <div class="spinner-border" role="status" style={{ "display": loaderProduct }}>
                        <span class="sr-only"></span>
                      </div>
                    </div>

                    <PaginationNew
                  number={pendfAppRecords}
                  paginate={paginate}
                  activ={selPgPendforappcat}
                  comp="pendinfforappPro"
                />

                    <div className='scrolltoptnCnt' style={{ "display": isPendforApprScrollBtnVis }}>
                      <a href='#pending'>
                        <Button variant="dark" style={{ "backgroundColor": "black", "color": "white" }} className='scroll_btn_invent'><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                      </a>

                    </div>
                    {pendforapprProductsList.length > 0 ? <div id="popup2" className="overlay" style={{ "display": isPopupVisiblePendfapp }}>
                      <Popup
                        name={pendforapprProductsList[currDetailPendforapp].product.productName}
                        price={pendforapprProductsList[currDetailPendforapp].purchase_price}
                        SKU={pendforapprProductsList[currDetailPendforapp].product.SKU}
                        popupVisibility={setpopupVisibility}
                        images={pendforapprProductsList[currDetailPendforapp].product.images}
                        description={pendforapprProductsList[currDetailPendforapp].product.description}
                        sdescription={pendforapprProductsList[currDetailPendforapp].product.shortDescription}
                        descriptionNew={pendforapprProductsList[currDetailPendforapp]?.descriptionNew||[]}
                        specificationNew={pendforapprProductsList[currDetailPendforapp]?.specificationNew||[]}
                        callback={productCheck}
                        lead={pendforapprProductsList[currDetailPendforapp]._id}
                      />
                    </div> : <></>}
                  </Tab>

                </Tabs>



              </section>


              {/* New request for approval */}
              {/* <section id="pendforappr" className="tab-panel">
               
              </section> */}
            </div>

          </div>


          {/* {updtProVisibility === true && combAttri.length > 0 && <UpdtProPopup2
            lead={clickedUpdateNo}
            productName={selectedProductPopup}
            callbackResFun={callbackResUpdate}
            combattr={combAttri}
            img={selectedImgPopup}
            detail={updtPopuprel}
            product={currentProupdt}
            Popupvisible="block"
            from="approved-Pro"
            Popupvisibilityfun={checkpopupvisibility}
          />
          } */}





          <Modal
            show={confirmationState}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <ConfirmationModal
              onHide={confirmationBoxHiding}
              pId={selectedProduct}
              selectedId={selectedId}
              msg={msgConfirmation}
              proresDeact={deactiveReason}
              responseconfirmationFun={responseconfirmation}
            />
          </Modal>
          {/* Toast */}
          <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
            <Toast.Header>
              <strong className="me-auto">Message</strong>
            </Toast.Header>
            <Toast.Body>{ToastMsg}</Toast.Body>
          </Toast>
        </div>
      </div>
    </>
  )

}




export default HomeNew;